import { ApiPayload } from '../api'

export { UefaApiResult as UefaScheduleListResult } from '@rtl/api'
export { UefaApiResult as UefaScoreListResult } from '@rtl/api'
export { UefaApiResult as UefaTeamStatResult } from '@rtl/api'
export { UefaApiResult as UefaPlayerStatResult } from '@rtl/api'

export type UefaScheduleListPayload = ApiPayload<{ season: UEFA_SEASON_ID }>
export type UefaScoreListPayload = ApiPayload<{ season: UEFA_SEASON_ID, _pgNm?: number, _pgSz?: number }>
export type UefaPlayerStatPayload = ApiPayload<{ season: UEFA_SEASON_ID }>
export type UefaTeamStatPayload = ApiPayload<{ season: UEFA_SEASON_ID }>

export interface UefaState {}

export enum UEFA_ACTION {
  SCHEDULE_LIST = 'fetchUefaScheduleList',
  SCORE_LIST = 'fetchUefaScoreList',
  PLAYER_STAT = 'fetchUefaPlayerStat',
  TEAM_STAT = 'fetchUefaTeamStat'
}

export enum UEFA_GETTER {
  API = 'api'
}

export const UEFA_NAMESPACE = 'uefa'

export enum UEFA_SEASON_ID {
  '2026-2027' = '99jev9kv55deht65t6myggxlg',
  '2025-2026' = '2mr0u0l78k2gdsm79q56tb2fo'
}
